// Cases are explicitly granted to active training accounts. Administrators retain practice access.
export function canUseCases(user) {
  return !!(user && (user.is_admin || (user.is_practitioner && user.practitioner_status === 'active' && (user.unlocked_features || []).includes('cases'))));
}
export function canUsePatients(user) {return !!user?.is_admin;}
export function isTrainingCase(record) { return record?.case_type === 'gurukul'; }
export function recordArea(record) {return isTrainingCase(record) ? 'cases' : 'patients';}
export function recordPath(record) {return `/praxis-tool/${recordArea(record)}/${record.id}`;}
export function canOpenRecordArea(user, area) {return area === 'cases' ? canUseCases(user) : area === 'patients' && canUsePatients(user);}
export function trainingMonthLabel(value, language = 'en') {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(value || '')) return '';
  return new Intl.DateTimeFormat(language === 'de' ? 'de-DE' : language === 'el' ? 'el-GR' : 'en-GB', {month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(`${value}-01T12:00:00Z`));
}
